module.exports = __webpack_public_path__ + "static/media/website-white-bg.069957c0.svg";